import { z } from 'zod';

import { BlockValueFieldSchemaV2, BlockValueFieldSchemaVariant } from './blockValueFieldSchema.js';
import { BlockValueTemplateHint, validateBlockValueTemplate } from './template.js';

/**
 * @arg stringValidationSchema - User supplied zod string schema that is checked if value is not a block
 * value template. e.g. `z.string().maxLength(20)`
 * @returns A Zod schema for validating values that are either block value templates or some zod string type.
 */
export function BlockValueStringSchema(args: {
  stringValidationSchema:
    | z.ZodString
    | z.ZodEffects<z.ZodString, string, string>
    | z.ZodPipeline<any, z.ZodString>;
}) {
  return z.coerce.string().superRefine((stringValue, context) => {
    const templateParseResult = BlockValueFieldSchemaV2({
      variant: BlockValueFieldSchemaVariant.TemplateOnly,
    }).safeParse(stringValue);
    if (templateParseResult.success) {
      return;
    }
    // We want to validate against string schema only if string is not template-like
    const templateValidation = validateBlockValueTemplate(stringValue);
    if (templateValidation.hint !== BlockValueTemplateHint.NotTemplateLike) {
      templateParseResult.error.errors.forEach((issue) => {
        context.addIssue(issue);
      });
      return;
    }
    const stringParseResult = args.stringValidationSchema.safeParse(stringValue);
    if (stringParseResult.success) {
      return;
    }
    stringParseResult.error.errors.forEach((issue) => {
      context.addIssue(issue);
    });
    templateParseResult.error.errors.forEach((issue) => {
      context.addIssue(issue);
    });
  });
}
